module.exports = __webpack_public_path__ + "media/credit/paypal-c11c3739.png";